import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationCreationFailedAction = {
	type: 'ORGANIZATION_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationCreationFailedAction => ({
	type: 'ORGANIZATION_CREATION_FAILED',
	payload,
});
